
/* IV-Drips Booking Modal v7 – Checkout Adress-Prefill + Geburtsdatum-Datepicker */
(function () {
  'use strict';

  var ADDR_KEY   = 'iv_checkout_addr'; // sessionStorage key

  var modal    = null;
  var _bypass  = false;
  var _lastBtn = null;

  /* ── Adress-Parameter für Shopify Checkout ── */
  function buildAddrParams(addr) {
    // addr = "Lindenweg 2, 55288 Armsheim"
    var parts = addr.split(',').map(function(s){ return s.trim(); });
    var address1 = parts[0] || '';
    var rest = parts[1] || '';
    // rest z.B. "55288 Armsheim"
    var zipCity = rest.split(' ').filter(Boolean);
    var zip  = zipCity[0] || '';
    var city = zipCity.slice(1).join(' ') || '';
    return [
      'checkout[shipping_address][address1]=' + encodeURIComponent(address1),
      'checkout[shipping_address][zip]='      + encodeURIComponent(zip),
      'checkout[shipping_address][city]='     + encodeURIComponent(city),
      'checkout[shipping_address][country]='  + encodeURIComponent('Germany'),
    ].join('&');
  }

  function injectAddrIntoUrl(url) {
    try {
      var addr = sessionStorage.getItem(ADDR_KEY);
      if (!addr) return url;
      var params = buildAddrParams(addr);
      return url + (url.indexOf('?') !== -1 ? '&' : '?') + params;
    } catch(e) { return url; }
  }

  function isCheckoutUrl(url) {
    return typeof url === 'string' && url.indexOf('/checkouts/') !== -1;
  }

  /* ── Checkout-Navigation abfangen ── */
  function interceptCheckout() {
    // 1) location.assign / location.replace
    try {
      var _assign  = window.location.assign.bind(window.location);
      var _replace = window.location.replace.bind(window.location);
      window.location.assign = function(url) {
        _assign(isCheckoutUrl(url) ? injectAddrIntoUrl(url) : url);
      };
      window.location.replace = function(url) {
        _replace(isCheckoutUrl(url) ? injectAddrIntoUrl(url) : url);
      };
    } catch(e) {}

    // 2) window.open
    var _open = window.open;
    window.open = function(url, target, features) {
      if (isCheckoutUrl(url)) url = injectAddrIntoUrl(url);
      return _open.call(window, url, target, features);
    };

    // 3) Klick auf <a href="/checkouts/...">
    document.addEventListener('click', function(e) {
      var a = e.target.closest('a');
      if (a && isCheckoutUrl(a.getAttribute('href') || '')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.assign(injectAddrIntoUrl(a.href));
      }
    }, true);

    // 4) fetch abfangen – Cowlendar erhält Checkout-URL vom Server
    var _fetch = window.fetch;
    window.fetch = function(url, opts) {
      return _fetch.apply(this, arguments).then(function(response) {
        var ct = response.headers.get('content-type') || '';
        if (!ct.includes('application/json')) return response;

        var addr = '';
        try { addr = sessionStorage.getItem(ADDR_KEY) || ''; } catch(e) {}
        if (!addr) return response;

        return response.text().then(function(text) {
          var modified = text.replace(
            /(https?:\/\/[^\"']*\/checkouts\/[^\"'?]+)/g,
            function(match) {
              return match + (match.indexOf('?') !== -1 ? '&' : '?') + buildAddrParams(addr);
            }
          );
          return new Response(modified, {
            status:     response.status,
            statusText: response.statusText,
            headers:    response.headers,
          });
        });
      });
    };

    // 5) XMLHttpRequest abfangen
    var _XHROpen  = XMLHttpRequest.prototype.open;
    var _XHRSend  = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(m, u) {
      this._ivUrl = u;
      return _XHROpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function() {
      var addr = '';
      try { addr = sessionStorage.getItem(ADDR_KEY) || ''; } catch(e) {}
      if (addr) {
        var xhr = this;
        var orig = Object.getOwnPropertyDescriptor(XMLHttpRequest.prototype, 'responseText');
        // responseURL nach checkout suchen
        this.addEventListener('load', function() {
          try {
            var txt = xhr.responseText;
            if (txt && txt.includes('/checkouts/')) {
              // Antwort enthält Checkout-URL – wird via fetch bereits abgefangen
            }
          } catch(e) {}
        });
      }
      return _XHRSend.apply(this, arguments);
    };
  }

  /* ── Cart helpers ── */
  function cartUpdate(payload, cb) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function(r){ return r.json(); })
      .then(function(){ cb && cb(); })
      .catch(function(e){ console.warn('[iv-booking] cart error', e); cb && cb(); });
  }

  /* ── Modal open / close ── */
  function openModal() {
    if (!modal) return;
    modal.classList.add('iv-bm--open');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('iv-bm--open');
    document.body.style.overflow = '';
  }

  /* ── Re-fire Cowlendar ── */
  function fireCowlendar() {
    _bypass = true;
    var btn = _lastBtn || document.querySelector('.cowlendar-btn');
    if (btn) btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    setTimeout(function(){ _bypass = false; }, 800);
  }

  /* ── Location chosen ── */
  function chooseLocation(name, address) {
    closeModal();

    if (!address) {
      // "Ort deiner Wahl" – Standort löschen
      try { sessionStorage.removeItem(ADDR_KEY); } catch(e) {}
      cartUpdate({ attributes: { iv_location: '', iv_location_address: '' }, note: '' }, fireCowlendar);
      return;
    }

    // Fester Standort – Adresse für Checkout-Prefill merken + Cart-Attrs setzen
    try { sessionStorage.setItem(ADDR_KEY, address); } catch(e) {}
    var note = 'Standort: ' + name + ' | Adresse: ' + address;
    cartUpdate(
      { attributes: { iv_location: name, iv_location_address: address }, note: note },
      fireCowlendar
    );
  }

  /* ── Init ── */
  function init() {
    interceptCheckout();

    modal = document.getElementById('iv-booking-modal');
    if (!modal) return;

    modal.addEventListener('click', function(e) {
      if (e.target === modal || e.target.closest('.iv-bm__close')) closeModal();
    });

    modal.querySelectorAll('.iv-bm__card').forEach(function(card) {
      card.addEventListener('click', function() {
        chooseLocation(card.dataset.name || '', card.dataset.address || '');
      });
    });

    document.addEventListener('click', function(e) {
      if (_bypass) return;
      var target = e.target.closest('button, a');
      if (!target) return;
      var txt = target.textContent.trim();
      var isBooking = (
        txt === 'Jetzt buchen' || txt === 'JETZT BUCHEN' ||
        target.classList.contains('iv-book-trigger') ||
        target.classList.contains('cowlendar-btn')
      );
      if (!isBooking) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      _lastBtn = target;
      openModal();
    }, true);
  }

  /* ── AGB Bugfix (nur versteckte/unlabeled required inputs) ── */
  function fixAGB(root) {
    var sel = ['[class*="cowlendar"]','[id*="cowlendar"]','[class*="cowl-"]','[id*="cowl-"]'].join(',');
    Array.from((root || document).querySelectorAll(sel)).forEach(function(c) {
      c.querySelectorAll('input, select, textarea').forEach(function(f) {
        if (f.type === 'checkbox' || f.type === 'radio') return;
        var label = f.id ? document.querySelector('label[for="' + f.id + '"]') : null;
        var labelTxt = label ? label.textContent.trim() : '';
        var isHiddenOrUnlabeled = f.required && (f.offsetParent === null || !labelTxt);
        if (isHiddenOrUnlabeled) {
          f.removeAttribute('required');
          var wrap = f.closest('[class*="field"], .form-group, [class*="row"]');
          if (wrap) wrap.style.display = 'none';
        }
      });
    });
  }

  /* ── Geburtsdatum: Textfeld → HTML5 Datepicker ── */
  var BIRTH_LABEL_RE = /geburts\s*datum|birth\s*date|date\s*of\s*birth/i;
  var BIRTH_PLACEHOLDER_RE = /(TT[.\/]MM[.\/]JJJJ)|(DD[.\/]MM[.\/]YYYY)/i;

  function isBirthdateField(f) {
    if (f.dataset.ivDate === '1') return false;
    if (f.type !== 'text' && f.type !== '') return false;
    var label = f.id ? document.querySelector('label[for="' + f.id + '"]') : null;
    var labelTxt = label ? label.textContent.trim() : '';
    return BIRTH_LABEL_RE.test(labelTxt)
        || BIRTH_PLACEHOLDER_RE.test(f.placeholder || '')
        || BIRTH_LABEL_RE.test(f.name || '');
  }

  function toIsoDate(s) {
    // "24.04.1990" → "1990-04-24"; sonst "" wenn unpassbar
    if (!s) return '';
    var m = /^(\d{1,2})[.\/](\d{1,2})[.\/](\d{4})$/.exec(s.trim());
    if (!m) return '';
    var d = m[1].padStart(2, '0'), mo = m[2].padStart(2, '0'), y = m[3];
    return y + '-' + mo + '-' + d;
  }

  function toGermanDate(iso) {
    // "1990-04-24" → "24.04.1990"
    if (!iso) return '';
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
    return m ? (m[3] + '.' + m[2] + '.' + m[1]) : iso;
  }

  function transformBirthdate(root) {
    var scope = root || document;
    var sel = ['[class*="cowlendar"]','[id*="cowlendar"]','[class*="cowl-"]','[id*="cowl-"]'].join(',');
    Array.from(scope.querySelectorAll(sel)).forEach(function(c) {
      c.querySelectorAll('input').forEach(function(f) {
        if (!isBirthdateField(f)) return;

        // Prefill aus evtl. vorhandenem "24.04.1990"-Wert
        var pre = toIsoDate(f.value);
        f.type = 'date';
        if (pre) f.value = pre;
        f.removeAttribute('placeholder');
        f.setAttribute('max', new Date().toISOString().slice(0, 10));
        f.dataset.ivDate = '1';

        // ISO-Datum wird zusätzlich als TT.MM.JJJJ in versteckten Mirror
        // gespiegelt, falls serverseitig das deutsche Format erwartet wird.
        var mirror = document.createElement('input');
        mirror.type = 'hidden';
        mirror.name = (f.name || 'birthdate') + '_de';
        mirror.dataset.ivDateMirror = '1';
        f.parentNode.insertBefore(mirror, f.nextSibling);

        function sync() { mirror.value = toGermanDate(f.value); }
        f.addEventListener('change', sync);
        f.addEventListener('input', sync);
        sync();
      });
    });
  }

  new MutationObserver(function(m) {
    m.forEach(function(mut) {
      mut.addedNodes.forEach(function(n) {
        if (n.nodeType !== 1) return;
        fixAGB(n);
        transformBirthdate(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // Initial pass (falls Widget schon gerendert ist)
  transformBirthdate(document);
  fixAGB(document);

  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeModal(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
